import axios from 'axios'
import config from './config'
import store from '@/store'
import endpoints from './endpoint'
import {
    Message,
} from 'element-ui'
import router from '@/routers'
import Qs from 'qs'

//axios实例
const axiosInstance = axios.create(config)

// 登录状态无效跳转登录页
function goLoginPage() {
    localStorage.removeItem("authorization");
    const roleCode = store.state.user.currentRoleCode;
    // 投稿人走学说pc的登录页面
    if (roleCode != "#ROLE1#ROLE2" && roleCode != "#ROLE1") {
        const curUrl = window.location.href.split('#')[0] + '#/index/' + localStorage.getItem('meetingCode');
        console.log('curUrl', curUrl)
        const url =
            process.env.VUE_APP_LOGIN_HOST +
            "/#/login?redirect=" +
            encodeURIComponent(curUrl);
        window.location.href = url;
    } else {
        router.push(
            "/login/" + localStorage.getItem('meetingCode')
        );
    }
}
// let loadingInstance;
export const requestMethod = function (url, data, method) {
    let request = {
        method: method,
        url: url
    }
    if (method == 'post') {
        if (request.headers && request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
            request.data = Qs.stringify(data);
        } else {
            request.data = JSON.stringify(data);
        }
    } else if (method == 'postObj') {
        request.method = 'post';
        request.params = data;
    } else if (method == 'get') {
        request.params = data;
    } else {
        return config.baseURL + url;
    }
    return axiosInstance(request)
}
// 请求拦截
axiosInstance.interceptors.request.use(function (config) {
    var authorization = localStorage.getItem('authorization')
    // var userId = localStorage.getItem('userId')
    var meetingCode = localStorage.getItem('meetingCode')
    config.headers.authorization = authorization;
    // config.headers.userId = userId;
    config.headers.meetingCode = meetingCode;
    if (config.url == '/crDoc/download') {
        config.responseType = 'blob';
    }
    return config
}, function (error) {
    return error
})
//返回拦截
axiosInstance.interceptors.response.use(function (response) {
    // loadingInstance.close()
    // code==4  未登录或登录过期
    if (response.config.url == "/crDoc/download") {
        return response
    } else {
        if (response.data.code == 4) {
            if (localStorage.getItem("currentUserId")) {
                Message.error({
                    message: response.data.message
                })
            }
        } else {
            if (response.data) {
                return response.data;
            }
            if (response.datas) {
                return response.datas;
            }
        }
    }

}, function (error) {
    // 10004登录态失效
    if (error.response.data.code == 10004) {
        // 非首页跳转登录页
        if (location.href.indexOf('index') == -1) {
            goLoginPage()
        } else {
            // 清空本地存储
            localStorage.clear();
            localStorage.setItem("lang", this.lang);
        }
    }
    return error
})

let VueAPI = {}
VueAPI.install = function (Vue) {
    Vue.prototype.$api = {}
    for (let key in endpoints) {
        //调用接口时，默认方式为'post', 如有需要，可在访问具体接口处，手动添加其他方式，如'get'
        Vue.prototype.$api[key] = function (data, method = 'post') {
            let url = endpoints[key]
            return requestMethod(url, data, method)
        }
    }
}
export default VueAPI
